const ExpenseForm = {
  setSelectListener(this: any, selector: string) {
    const select = document.querySelector(selector);
    select?.addEventListener("change", () => {
      select.dispatchEvent(new Event("input", { bubbles: true }));
    });
  },
  mounted(this: any) {
    this.setSelectListener(
      "select[id^='invoice-form_expenses'][id$='_currency_code']",
    );
    this.setSelectListener(
      "select[id^='invoice-form_expenses'][id$='_product_type_id']",
    );
    this.handleEvent("remove_seafarer", ({ id, target }: any) => {
      this.pushEventTo(target, "remove_seafarer", { id: id });
    });
  },
};

export default ExpenseForm;
